import { createTheme } from "@material-ui/core/styles";

const fontFamily = "\"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif";

// A custom theme for this app based on Figma plans: https://www.figma.com/file/KbVJyoshPXdz8i1L7facIi/PARKIR
const theme = createTheme({
    typography: {
        fontFamily: fontFamily,
        allVariants: {
            fontFamily: fontFamily
        },
        body1: {
            fontSize: "14px"
        },
        body2: {
            fontSize: "12px"
        }
    },
    palette: {
        type: "light",
        primary: {
            main: "#357B5C",
            light: "#408C6A",
            dark: "#1A563C",
            contrastText: "#fff"
        },
        secondary: {
            main: "#A8A8A8",
            light: "#C5C3C3",
            dark: "#696A6A",
            contrastText: "#fff"
        },
        error: {
            main: "#DB251B",
            light: "#F9DAD9",
            dark: "#6C130E"
        },
        warning: {
            main: "#D7A562",
            light: "#FAF4EC",
            dark: "#6B5332"
        },
        success: {
            light: "#FAF4EC",
            // dark will be calculated from dark and light
            main: "#3E6040"
        },
        background: {
            default: "#282c34"
        }
    },
    overrides: {
        MuiPaper: {
            root: {
                padding: "20px 10px",
                margin: "10px",
                backgroundColor: "#fff" // 5d737e
            }
        },
        MuiButton: {
            root: {
                margin: "5px"
            }
        },
        MuiToolbar: {
            regular: {
                minHeight: "64px"
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: "none"
            }
        }
    }
});
export default theme;
